/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Zotero_Thesis_TitleInputs */

const en_why_listening_zotero_thesis_title = /** @type {(inputs: Why_Listening_Zotero_Thesis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilingual working memory`)
};

const es_why_listening_zotero_thesis_title = /** @type {(inputs: Why_Listening_Zotero_Thesis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memoria de trabajo bilingüe`)
};

/**
* | output |
* | --- |
* | "Bilingual working memory" |
*
* @param {Why_Listening_Zotero_Thesis_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_zotero_thesis_title = /** @type {((inputs?: Why_Listening_Zotero_Thesis_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Zotero_Thesis_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_zotero_thesis_title(inputs)
	return en_why_listening_zotero_thesis_title(inputs)
});